export const blockCodeEditor = (editor) => {
    const pn = editor.Panels;
    const panelViews = pn.addPanel({
        id: 'views',
    });
    panelViews.get('buttons').add([
        {
            attributes: {
                title: 'Open Code',
            },
            className: 'fa fa-file-code-o',
            command: 'open-code',
            togglable: false, //do not close when button is clicked again
            id: 'open-code',
        },
    ]);
};
